import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Instagram, Twitter, Linkedin } from 'lucide-react';
import { hotelInfo } from '../mock';

export const Footer = () => {
  const quickLinks = [
    { path: '/', label: 'Home' },
    { path: '/accommodation', label: 'Accommodation' },
    { path: '/dining', label: 'Food & Beverage' },
    { path: '/wellness', label: 'Health Club & Wellness' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <footer className="bg-white border-t mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <Link to="/" className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_premiumlodging/artifacts/e3vc932j_New%20Project.png" 
                alt="Pauline Hotels Logo" 
                className="h-15 w-auto"
                style={{ height: '60px' }}
              />
            </Link>
            <p className="text-sm text-gray-600 mb-4">
              Experience luxury, comfort, and exceptional service at Pauline Hotels. Your perfect stay awaits.
            </p>
            <div className="flex space-x-4">
              <a
                href={hotelInfo.socialMedia.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors hover:opacity-70"
                style={{ color: '#102854' }}
              >
                <Facebook size={20} />
              </a>
              <a
                href={hotelInfo.socialMedia.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors hover:opacity-70"
                style={{ color: '#102854' }}
              >
                <Instagram size={20} />
              </a>
              <a
                href={hotelInfo.socialMedia.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors hover:opacity-70"
                style={{ color: '#102854' }}
              >
                <Twitter size={20} />
              </a>
              <a
                href={hotelInfo.socialMedia.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="transition-colors hover:opacity-70"
                style={{ color: '#102854' }}
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4" style={{ color: '#102854' }}>
              Quick Links
            </h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-gray-600 hover:opacity-70 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4" style={{ color: '#102854' }}>
              Contact Us
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="mt-1" style={{ color: '#C9A961' }} />
                <span className="text-sm text-gray-600">{hotelInfo.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} style={{ color: '#C9A961' }} />
                <span className="text-sm text-gray-600">{hotelInfo.phone}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} style={{ color: '#C9A961' }} />
                <span className="text-sm text-gray-600">{hotelInfo.email}</span>
              </li>
            </ul>
          </div>

          {/* Google Map */}
          <div>
            <h3 className="text-lg font-semibold mb-4" style={{ color: '#102854' }}>
              Location
            </h3>
            <div className="w-full h-48 rounded-lg overflow-hidden">
              <iframe
                title="Hotel Location"
                src={hotelInfo.mapUrl}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
              />
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t mt-8 pt-8 text-center">
          <p className="text-sm text-gray-600">
            © {new Date().getFullYear()} Pauline Hotels. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};